export default {
  FETCH_LOTTERY_CONTACTS_REQUEST: 'FETCH_LOTTERY_CONTACTS_REQUEST',
  FETCH_LOTTERY_CONTACTS_SUCCESS: 'FETCH_LOTTERY_CONTACTS_SUCCESS',
  FETCH_LOTTERY_CONTACTS_FAILURE: 'FETCH_LOTTERY_CONTACTS_FAILURE',

  DISCARD_LOTTERY_CONTACTS_CHANGES_REQUEST: 'DISCARD_LOTTERY_CONTACTS_CHANGES_REQUEST',
  DISCARD_LOTTERY_CONTACTS_CHANGES_SUCCESS: 'DISCARD_LOTTERY_CONTACTS_CHANGES_SUCCESS',
  DISCARD_LOTTERY_CONTACTS_CHANGES_FAILURE: 'DISCARD_LOTTERY_CONTACTS_CHANGES_FAILURE',

  PUBLISH_LOTTERY_CONTACTS_CHANGES_REQUEST: 'PUBLISH_LOTTERY_CONTACTS_CHANGES_REQUEST',
  PUBLISH_LOTTERY_CONTACTS_CHANGES_SUCCESS: 'PUBLISH_LOTTERY_CONTACTS_CHANGES_SUCCESS',
  PUBLISH_LOTTERY_CONTACTS_CHANGES_FAILURE: 'PUBLISH_LOTTERY_CONTACTS_CHANGES_FAILURE',

  FETCH_INQUIRY_CONTACTS_REQUEST: 'FETCH_INQUIRY_CONTACTS_REQUEST',
  FETCH_INQUIRY_CONTACTS_SUCCESS: 'FETCH_INQUIRY_CONTACTS_SUCCESS',
  FETCH_INQUIRY_CONTACTS_FAILURE: 'FETCH_INQUIRY_CONTACTS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/contact/actions/action-types.js